import {makeAutoObservable} from "mobx";
import {AcquisitionListItemDto, AcquisitionStatusDto} from "../../api/sca";
import {api, catchApi} from "../../api";

class ScaOverviewStore {
    get status(): AcquisitionStatusDto[] | undefined {
        return this._status;
    }

    set status(value: AcquisitionStatusDto[] | undefined) {
        this._status = value;
    }
    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }
    get toAbsolute(): string | undefined {
        return this._toAbsolute;
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value;
    }
    get fromAbsolute(): string | undefined {
        return this._fromAbsolute;
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }
    get toRelative(): string | undefined {
        return this._toRelative;
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value;
    }
    get fromRelative(): string | undefined {
        return this._fromRelative;
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }
    get query(): string | undefined {
        return this._query;
    }

    set query(value: string | undefined) {
        this._query = value;
    }
    get size(): number {
        return this._size;
    }

    set size(value: number) {
        this._size = value;
    }
    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
    }
    get pages(): number {
        return this._pages;
    }

    set pages(value: number) {
        this._pages = value;
    }
    get items(): AcquisitionListItemDto[] {
        return this._items;
    }

    private set items(value: AcquisitionListItemDto[]) {
        this._items = value;
    }

    private _items: AcquisitionListItemDto[] = []

    private _pages: number = 0
    private _page: number = 0
    private _size: number = 25
    private _query: string | undefined
    private _fromRelative: string | undefined
    private _toRelative: string | undefined
    private _fromAbsolute: string | undefined
    private _toAbsolute: string | undefined
    private _customerId: string | undefined
    private _status: AcquisitionStatusDto[] | undefined
    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const {
            page,
            size,
            query,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            status
        } = this

        const response = await catchApi(async () => api.sca.api.getSecurityCodeAcquisitionList({
            page: page - 1,
            size,
            q: query,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            status
        }))

        const responseData = response?.data
        this.pages = responseData?.totalPages || 0
        this.items = (responseData?.items || [])
    }
}

const scaOverviewStore = new ScaOverviewStore()

export {
    scaOverviewStore
}
